module.exports = __webpack_public_path__ + "img/gnl_godsnlegends.75899fb.png";